(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mokie-occasions"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mokie-occasions-v1')) {
    class MokieOccasionsV1 extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        if (this.events) this.events.abort();
        this.events = null;
      }

      initialize() {
        if (this.events) this.events.abort();
        if (this.dataset.layout !== 'spotlight') return;
        this.tabs = Array.from(this.querySelectorAll('[data-mokie-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-mokie-card]'));
        this.tablist = this.querySelector('[data-mokie-tabs]');
        if (!this.tablist || !this.tabs.length || this.tabs.length !== this.panels.length) return;

        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.panels.forEach((panel, index) => {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', this.tabs[index].id);
          panel.tabIndex = 0;
        });
        const activeIndex = this.tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true');
        this.activate(activeIndex >= 0 ? activeIndex : 0, false);
        this.tablist.hidden = this.tabs.length < 2;

        this.addEventListener('click', event => {
          const tab = event.target.closest('[data-mokie-tab]');
          const index = this.tabs.indexOf(tab);
          if (index >= 0) this.activate(index, false);
        }, options);

        this.addEventListener('keydown', event => {
          const tab = event.target.closest('[data-mokie-tab]');
          const index = this.tabs.indexOf(tab);
          if (index < 0) return;
          let nextIndex;
          const rtl = getComputedStyle(this.tablist).direction === 'rtl';
          if (event.key === 'ArrowRight') nextIndex = index + (rtl ? -1 : 1);
          else if (event.key === 'ArrowLeft') nextIndex = index + (rtl ? 1 : -1);
          else if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = this.tabs.length - 1;
          else return;
          event.preventDefault();
          this.activate((nextIndex + this.tabs.length) % this.tabs.length, true);
        }, options);

        this.addEventListener('shopify:block:select', event => {
          const blockId = event.detail && event.detail.blockId;
          const index = this.panels.findIndex(panel => panel.dataset.mokieCard === blockId);
          if (index >= 0) {
            this.activate(index, false);
            this.panels[index].scrollIntoView({ block: 'nearest', behavior: 'auto' });
          }
        }, options);
      }

      activate(index, moveFocus) {
        if (!this.tabs[index]) return;
        this.tabs.forEach((tab, position) => {
          const selected = position === index;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          this.panels[position].hidden = !selected;
        });
        if (moveFocus) this.tabs[index].focus();
      }
    }
    customElements.define('mokie-occasions-v1', MokieOccasionsV1);
  }

  } catch(e) { console.error(e); }
})();
})();
